export default "__VITE_ASSET__sfl1dvG9__"